import { definitionsFromContext } from '@hotwired/stimulus-webpack-helpers';
import { application } from './application';

const context = require.context('./', true, /\.tsx?$/);
application.load(definitionsFromContext(context));
